import { isFlagToolingEnabled } from '../enabled';

if (isFlagToolingEnabled()) {
  // eslint-disable-next-line @typescript-eslint/no-require-imports
  require('./register');
}
